import './AboutSubscribe.css';

export default function AboutSubscribe() {
    const docNumber = Math.floor(100000 + Math.random() * 900000);

    return (
        <div className='about-subscribe'>
            <div className="document">

                <header className="document__header">
                    <h1>Положение об абонементах</h1>
                    <p className="document__subtitle">
                        Настоящий документ регулирует условия использования абонементов
                        в рамках записи на занятия и мероприятия студии.
                    </p>
                </header>

                <section className="document__block">
                    <h2>1. Общие положения</h2>
                    <p>
                        Абонемент представляет собой персональный электронный доступ к посещению занятий.
                        После приобретения пользователю присваивается уникальный номер:
                        <span className="doc-id">№ {docNumber}</span>.
                        Данный номер фиксируется в системе и направляется на указанную электронную почту.
                    </p>
                </section>

                <section className="document__block">
                    <h2>2. Условия использования</h2>
                    <p>
                        При покупке абонемента пользователь подтверждает согласие с правилами его использования.
                        Каждое записанное посещение занятия списывает одно посещение с баланса абонемента.
                    </p>
                    <p>
                        В случае неявки на занятие при предварительной записи,
                        посещение также считается использованным и подлежит списанию.
                    </p>
                </section>

                <section className="document__block">
                    <h2>3. Ответственность пользователя</h2>
                    <p>
                        Пользователь самостоятельно контролирует остаток посещений и корректность записей.
                        Администрация не несёт ответственности за пропущенные занятия по инициативе пользователя.
                    </p>
                </section>

                <section className="document__block">
                    <h2>4. Дополнительные условия</h2>
                    <p>
                        Абонемент является персональным и не подлежит передаче третьим лицам.
                        В случае выявления нарушений администрация оставляет за собой право приостановить действие абонемента.
                    </p>
                </section>

                <footer className="document__footer">
                    <p>
                        Использование абонемента означает полное согласие с изложенными условиями.
                    </p>
                </footer>

            </div>
        </div>
    );
}